export {WsBrandMark} from './ws-brand-mark.js';
